import produce from "immer";
import { EMPTY_SOR } from "src/globalConsts";
import {
  FETCH_FAVOURITE_TEMPLATES_ERROR,
  FETCH_FAVOURITE_TEMPLATES_REQUEST,
  FETCH_FAVOURITE_TEMPLATES_SUCCESS,
  TOGGLE_FAVOURITE_TEMPLATE_ERROR,
  TOGGLE_FAVOURITE_TEMPLATE_LOCAL,
  TOGGLE_FAVOURITE_TEMPLATE_SUCCESS,
} from "./actionTypes";

import { NumberIndexedDictionary } from "../../globalTypes";
import {
  FavouriteTemplatesActionTypes,
  FavouriteTemplateSTORE,
  SFavouriteTemplatesSlice,
} from "./types";

const initialState: SFavouriteTemplatesSlice = {
  isFetching: false,
  byTemplateId: [],
};

const reducer = (
  state = initialState,
  action: FavouriteTemplatesActionTypes
): SFavouriteTemplatesSlice => {
  const { byTemplateId } = state;
  const favouriteIds = Object.keys(byTemplateId).map(Number);

  switch (action.type) {
    case TOGGLE_FAVOURITE_TEMPLATE_LOCAL: {
      const toggledId = Number(action.payload);

      return {
        ...state,
        byTemplateId: produce(byTemplateId, (draft) => {
          if (favouriteIds.includes(toggledId)) {
            delete draft[toggledId];
          } else {
            const highestOrder = Object.values(draft).reduce(
              (acc, curr) => Math.max(curr.order, acc),
              0
            );
            // Dummy item, než refetchnu data
            draft[toggledId] = {
              id: NaN,
              order: highestOrder + 1,
              template: toggledId,
              name: "",
              image: "",
              description: "",
              kpiMetadata: null,
              type: "overview",
            };
          }
        }),
      };
    }
    case TOGGLE_FAVOURITE_TEMPLATE_SUCCESS:
      return {
        ...state,
      };

    case TOGGLE_FAVOURITE_TEMPLATE_ERROR:
      // Todo: opravit, aby se to zas oddělalo
      return {
        ...state,
      };

    case FETCH_FAVOURITE_TEMPLATES_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_FAVOURITE_TEMPLATES_SUCCESS:
      return {
        ...state,
        byTemplateId: action.payload.reduce((acc, curr) => {
          acc[curr.template] = curr;
          return acc;
        }, {} as NumberIndexedDictionary<FavouriteTemplateSTORE>),
        isFetching: false,
      };

    case FETCH_FAVOURITE_TEMPLATES_ERROR:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default reducer;
